<template>
  <nav v-if="!isH5">
    <ul>
      <li v-for="(item, index) in navItems" :key="item.id"  @mouseenter="toggleDropdown(index)" 
        @mouseleave="toggleDropUp(index)"
        :class="[
          item.name!=$t('search.language_4')&&item.drophover && navStyle ? 'dropdown-hover' :item.drophover && !navStyle ? 'dropdown-hover-white' : '',
          isActive(item) ? 'active-nav' : ''
        ]">
        <template v-if="item.name == $t('search.language_4')" >
          <!-- <button class="header-search" type="button" title="Search" @click.stop="openSearch"> -->
            <!-- Search -->
            <i class="el-icon-search" style="margin-left: 10px;" @click.stop="openWebSearch"></i>
            <span class="language-btn" style="margin-left: 50px;" @click.stop="checkLanguage">{{ Language }}</span>
            <span class="fav-nav-wrapper" style="margin-left: 20px; position: relative; display: inline-block; vertical-align: middle; cursor: pointer;" @click.stop="goToFavorites" :title="$t('personalCenter.favorites')">
              <svg class="fav-nav-icon" width="22" height="22" viewBox="0 0 24 24">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" :fill="favCount > 0 ? '#e0245e' : 'none'" :stroke="favCount > 0 ? '#e0245e' : '#fff'" stroke-width="1.5" stroke-linejoin="round"/>
              </svg>
              <span v-if="favCount > 0" class="fav-count-badge">{{ favCount > 99 ? '99+' : favCount }}</span>
            </span>
            <div class="search-body" v-show="searchShow">
              <Search @closeSearch="closeWebSearch"></Search>
            </div>
          <!-- </button> -->
        </template>
        <template v-else>
          <a :href="herfUrl(item)" @click.prevent="handleNavClick(item)" rel="noopener noreferrer"
             :class="isActive(item) ? 'active-nav-link' : ''">
            {{ item.name }}
            <div v-show="item.drophover&&item.name==$t('message.language_1')" @mouseenter="toggleDropdown(index)"
              @mouseleave="toggleDropUp(index)"  class="dropdown-content" :class="item.drophover && navStyle ? 'dropdown-hover-white' : item.drophover && !navStyle ? 'dropdown-hover' : ''">
              <div class="product">
                <div class="list">
                  <div class="list-item" v-for="items in drawerList" :key="items.id" v-show="items.categoryState==1">
                    <p class="red-name">{{items.categoryName}}</p>
                        <p v-for="item2 in items.children" :key="item2.id" @click.prevent.stop="goProduct(item2,index)" @mouseenter="getChildren(item2,items.categoryName,item2.categoryName)" v-show="item2.categoryState==1">
                          {{ item2.categoryName }}
                          <img v-show="actionIndex==item2.id&&item.drophover && !navStyle"  src="@/assets/image/Arrow_cir.png" alt="">
                          <img v-show="actionIndex==item2.id&&item.drophover && navStyle"  src="@/assets/image/Arrow_cirr_W.png" alt="">
                        </p>
                    </div>
                </div>
                <div class="items">
                  <div v-for="item3 in drawerListTwo" :key="item3.id" class="item" @click.stop.prevent="goProductDetails(item3,index)" @mouseenter="getChildrenTwo(item3)" v-show="item3.categoryState==1">
                    <img :src="baseUrl+item3.imagePath" :alt="item3.categorySeo" class="imagess">
                    <p class="name">
                      {{ item3.categoryName }}
                    </p>
                  </div>
                </div>
              </div>
          </div>
          <!-- <div v-show="item.drophover&&(item.name=='News'||item.name=='About us')" @mouseenter="toggleDropdown(index)"
              @mouseleave="toggleDropUp(index)"  class="dropdown-content dropdown-select" :class="item.drophover && navStyle ? 'dropdown-hover-white' : item.drophover && !navStyle ? 'dropdown-hover' : ''">
            <div v-for="subitem in item.children" :key="subitem.name" class="subitem" @click.stop.prevent="navigatorTo(subitem)">
              {{ subitem.name }}
            </div>
          </div> -->
         </a>
        </template>
        </li>
    </ul>
    <el-dialog
      :visible.sync="languageDialog"
      width="20%"
      append-to-body
      :show-close="false"
      class="language-dialog"
      >
      <span class="language-item" v-for="langItem in langList" :key="langItem" @click="changeLanguage(langItem)"><span style="margin-right:10px ;" class="fi " :class="'fi-'+(langItem.code).toLocaleLowerCase()"></span>{{ langItem.text }}</span>
    </el-dialog>
  </nav>
  <nav v-else>
    <Accordion v-for="(item, index) in navItems" :key="index" v-show="item.name != $t('search.language_4')" >
      <AccordionItem :header="item.name" :isOpen="true"  :isRight="item.name == $t('message.language_1')" >
        <template #header>
          <!-- 非产品分类：点击直接跳转；产品分类：只展开手风琴不跳转 -->
          <div @click="item.name != $t('message.language_1') ? navigatorTo(item) : null">
              {{item.name }}
          </div>
        </template>
        <slot>
          <Accordion v-for="items in drawerList" :key="items.id" v-show="item.name==$t('message.language_1')&&items.categoryState==1">
            <AccordionItem :header="items.categoryName" :isOpen="true" :isRight="items.categoryName">
              <slot>
                <p v-for="item2 in items.children" :key="item2.id"   @click.stop="goProductDetail(item2)" v-show="item2.categoryState==1">
                    {{ item2.categoryName }}
                </p>
              </slot>
            </AccordionItem>
          </Accordion>
        </slot>
      </AccordionItem>
    </Accordion>
  </nav>
</template>
<script>
import { buildTree } from '@/utils/index';
import {getProductType} from '@/api/home';
import { getFavIdList } from '@/api/favorite'
import { listenEvent } from '@/utils/eventBus'
import Search from '@/components/search';
import Accordion from '@/components/accordion/accordion.vue';
import AccordionItem from '@/components/accordion/accordionItem.vue';
import i18nMonitorMixin from '@/mixins/i18n-monitor-mixin';
import pageRefreshMixin from '@/mixins/page-refresh-mixin';
import { encodeParam } from '@/utils/urlCrypto'

export default {
  name: 'DropdownNavbar',
  mixins: [i18nMonitorMixin, pageRefreshMixin], // 使用混入获得统一的路由、语言和刷新功能
  components: {
    Accordion,  
    AccordionItem,
    Search
  },
  props: {
    navItems: {
      type: Array,
      default: [],
    },
    navStyle: {
      type: Boolean,
      default: false
    },
    // 从父组件接收搜索控制方法
    openSearch: {
      type: Function,
      default: () => {}
    },
    closeSearch: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      searchShow:false,
      drawer: false,
      drawerList:[],
      actionIndex:0,
      drawerListTwo:[],
      actionIndexTwo:0,
      drawerListThree:[],
      list:[],
      hoverImage:'',
      type:'',
      title:'',
      isH5:false,
      isClickedRecently: false,
      clickImmunityTimeout: null, 
      baseUrl:process.env.VUE_APP_BASE_API,
      Language:"English",
      languageDialog:false,
      langList: [{text:'English',code:'gb',country:'en'},{text:'中文简体',code:'cn',country:'cn'} ,{text:'Россия',code:'ru',country:'by'} ,{text:'Espanha',code:'es',country:'es'},{text:'Francês',code:'fr',country:'fr'}],
      supportedLanguages:['en','cn','by','es','fr'],
      favCount: 0,
    };
  },
  watch: {
    '$store.state.user.token': function(newVal, oldVal) {
      if (!!newVal !== !!oldVal) {
        this.fetchFavCount()
      }
    }
  },
  created(){
    this.getProducts();
    // 监听收藏变化事件，实时更新徽标数字
    listenEvent('fav-changed', () => {
      this.fetchFavCount()
    })
  },
  mounted(){
    // 修复isH5初始化问题，与myheader组件保持一致
    const storedIsH5 = window.localStorage.getItem('isH5');
    this.isH5 = storedIsH5 ? JSON.parse(storedIsH5) : false;
    console.log('Navbar mounted, isH5:', this.isH5);
    
    let lang=localStorage.getItem("language");
    if(lang){
      let l= JSON.parse(lang);
      this.Language=l.text;
      let path=this.$route.path.split("/")[1];
      if(path!=lang.country){
        this.changeLanguage(l);
      }else{

      }
      
    }else{
      this.Language="English"
      this.changeLanguage({text:'English',code:'gb',country:'en'});
    }
    
    // 监听语言切换，重新加载产品数据
    this.$store.watch(
      state => state.user.language,
      (newLang, oldLang) => {
        if (newLang && oldLang && newLang.country !== oldLang.country) {
          this.getProducts();
        }
      },
      { deep: true }
    );

    // 初始加载收藏数量
    this.fetchFavCount()
  },
  methods: {
    openWebSearch(){
      this.searchShow=true;
    },
    goToFavorites() {
      if (this.$route.name === 'FavoritesPage') return;
      const currentLang = this.$store.state.user.lang || 'en';
      this.$router.push({ path: `/${currentLang}/favorites` }).catch(function(){});
    },
    async fetchFavCount() {
      var token = this.$store.state.user.token
      if (token) {
        try {
          var res = await getFavIdList()
          var ids = res.data
          this.favCount = Array.isArray(ids) ? ids.length : 0
        } catch (e) {
          console.error('Fetch fav count error:', e)
        }
      } else {
        try {
          var localFav = JSON.parse(localStorage.getItem('localFav') || '[]')
          this.favCount = Array.isArray(localFav) ? localFav.length : 0
        } catch (e) {
          this.favCount = 0
        }
      }
    },
    closeWebSearch(){
      this.searchShow=false;
    },
    // 统一的数据刷新方法
    async refreshData() {
      try {
        
        // 重新加载产品分类数据
        await this.getProducts()
      } catch (error) {
        console.error('❌ Failed to refresh navbar data:', error)
      }
    },
    
    // 获取产品分类数据
    async getProducts() {
      try {
        const params = { pageNum: 1, pageSize: 0 };
        const res = await getProductType(params);
        if (res.code === 200) {
          this.list = res.rows;
          this.drawerList = buildTree(res.rows);
        } else {
          //console.error('Failed to load product categories:', res.message);
        }
      } catch (error) {
        console.error('Error loading product categories:', error);
      }
    },
    
    changeLanguage(e){
      this.Language=e.text;
      this.$store.dispatch('user/toggleLanguage',e);
      // 更新i18n语言设置
      this.$i18n.locale =  e.country; 
      // this.$router.go(0)
      //
      this.handleClose();
    },
    handleClose(){
      this.languageDialog=false;
    },
    checkLanguage (){
      this.languageDialog=true;
    },
    // 处理导航点击事件
    async handleNavClick(item) {
      // 如果是搜索项，不进行跳转
      if(item.name === this.$t('search.language_4') || !item.url || item.url === '') {
        return;
      }
      
      try {
        await this.$navigateTo(item.url);
      } catch (error) {
        console.error('Navigation failed:', error);
      }
    },
    
    // 优化URL构建UI方法（使用新的统一API）
    herfUrl(item){
      // 如果是搜索项，返回空
      if(item.name === this.$t('search.language_4')) return ;
      if(!item.url || item.url === '') return '#';
      
      
      
      // 使用新的buildHref方法构建链接
      return this.$buildHref(item.url);
    },
    openSearchProps(){
      if(this.isH5)this.close();
      // 调用父组件传递过来的方法
      this.$props.openSearch();
    },
    // 优化后的路由跳转方法（使用新的统一API）
    async navigatorTo(e, index) {
      this.close();
      
      if (!e.url) return;
      
      let urls = e.url.split('?');
      if (this.$route.path === urls[0]) {
        return;
      }
      
      try {
        await this.$navigateTo(e.url);
      } catch (error) {
        console.error('Navigation failed:', error);
      }
      
      this.toggleDropUp(index);
    },
    
    async goProduct(item, index) {
      this.close();

      try {
        if (item.children.length) {
          await this.$navigateTo('/products', {
            query: {
              id: item.id,
              title: item.categoryName,
              search: item.categoryName
            }
          });
        } else {
          await this.$redirectTo('/products');
        }
      } catch (error) {
        console.error('Navigation failed:', error);
      }

      this.toggleDropUp(index);
    },

    // 移动端：点击父分类（如 Indoor/Outdoor）跳转到产品页并带上分类筛选
    async goParentCategory(item) {
      try {
        await this.$navigateTo('/products', {
          query: {
            id: item.id,
            title: item.categoryName,
            search: item.categoryName
          }
        });
      } catch (error) {
        console.error('Navigation failed:', error);
      }
      this.close();
    },
    async goProductDetail(item, index) {
      try {
        await this.$redirectTo('/products', {
          query: {
            pid: encodeParam(item.id),
            type: this.type,
            search: item.categoryName
          }
        });
      } catch (error) {
        console.error('Navigation failed:', error);
      }

      this.close();
      this.toggleDropUp(index);
    },

    async goProductDetails(item, index) {
      try {
        const result = await this.$navigateTo('/products/detail', {
          query: {
            pid: encodeParam(item.id),
            title: this.title || item.categoryName,
            type: this.type,
            product: item.categoryName
          }
        });
        
        // 检查是否需要刷新页面
        if (this.$isCurrentRoute('/products/detail')) {
          this.$refreshPage();
        }
      } catch (error) {
        console.error('Navigation failed:', error);
      }
      
      this.close();
      this.toggleDropUp(index);
    },
    getChildren(item, _i, t){
      this.close();
      this.drawerListTwo=item.children;
      this.actionIndexTwo='';
      this.actionIndex=item.id;
      this.title=item.categoryName;  // 当前 hover 的子分类名（如 "Recessed spotlights"），而非父级
      this.type=t;
      this.hoverImage=this.baseUrl+item.imagePath;
    },
    getChildrenTwo(item){
      this.close();
      this.actionIndexTwo=item.id;
      this.hoverImage=this.baseUrl+item.imagePath;
    },
    toggleDropdown(index) {
      if (this.navItems[index].dropdown) this.$set(this.navItems[index].dropdown, 'visible', true);
      else if (!this.navItems[index].drophover) {this.$set(this.navItems[index], 'drophover', true); }
    },
    toggleDropUp(index) {
      if (this.navItems[index].dropdown) this.$set(this.navItems[index].dropdown, 'visible', false);
      else if (this.navItems[index].drophover) { this.$set(this.navItems[index], 'drophover', false); }
    },
    close(){
      this.$emit("closeFun")
    },
    // 判断当前导航项是否为活动状态
    isActive(item) {
      if (!item.url || item.url === '') return false;
      
      // 获取当前路由路径
      const currentPath = this.$route.path;
      
      // 移除URL中的查询参数，只比较路径部分
      const itemPath = item.url.split('?')[0];
      
      // 处理特殊情况：首页
      if (itemPath === `/${this.$store.state.user.lang || 'en'}/` && currentPath === `/${this.$store.state.user.lang || 'en'}/`) {
        return true;
      }
      
      // 检查当前路径是否包含导航项的路径
      // 例如：导航项路径是 /en/products，当前路径是 /en/products/detail
      return currentPath.startsWith(itemPath);
    }
  }
};
</script>
<style scoped >
@import './navbar.css';
</style>
